import React, { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

const ADSENSE_CLIENT = 'ca-pub-2881060081023284';
const AD_SLOT = '6912567940';
const SCRIPT_ID = 'adsense-script';

let scriptLoaded = false;
let scriptLoading = false;

function loadAdsenseScript() {
  if (scriptLoaded || scriptLoading) return;
  if (document.getElementById(SCRIPT_ID)) { scriptLoaded = true; return; }
  scriptLoading = true;
  const s = document.createElement('script');
  s.id = SCRIPT_ID;
  s.async = true;
  s.crossOrigin = 'anonymous';
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
  s.onload = () => { scriptLoaded = true; scriptLoading = false; };
  s.onerror = () => { scriptLoading = false; };
  document.head.appendChild(s);
}

const AdBanner = ({ size = 'banner', className = '' }) => {
  const { user } = useAuth();
  const adRef = useRef(null);
  const pushed = useRef(false);

  const isPremium = user && (
    user.role === 'admin' || user.role === 'owner' ||
    ['premium', 'premium_plus', 'premium_annual', 'premium_basic'].includes(user.subscription_plan)
  );

  useEffect(() => {
    if (isPremium || pushed.current) return;
    loadAdsenseScript();
    const timer = setTimeout(() => {
      try {
        if (window.adsbygoogle && adRef.current && !pushed.current) {
          pushed.current = true;
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
      } catch (e) {}
    }, 1000);
    return () => clearTimeout(timer);
  }, [isPremium]);

  if (isPremium) return null;

  const height = size === 'largeBanner' ? '100px' : '50px';

  return (
    <div className={`ad-container w-full flex justify-center ${className}`} data-testid="ad-banner">
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'inline-block', width: '320px', height }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={AD_SLOT}
      />
    </div>
  );
};

export default AdBanner;
